module.exports = __webpack_public_path__ + "d3f662d50e92233122c81162caa91b06.svg";